import { getBrowserTimeZone } from './dateTime';

/**
 * 取客户端所在地区的 BCP 47 标签（如 "zh-TW"、"es-MX"），原样下发、不做任何映射或截断。
 *
 * 这里刻意<b>不读</b> i18n：X-Locale 记录的是「用户真实所在地区」这一客户端环境事实，
 * 与「用户在 LanguageSwitcher 里选的界面语言」是两条相互独立的线。一个把界面切成中文、
 * 浏览器区域为 en-US 的用户，X-Locale 应当如实上报 en-US。取值口径与同组的 X-Timezone
 * 一致——都取客户端环境事实，不掺杂应用内的用户选择。
 *
 * 取不到时返回 undefined，由调用方省略该请求头，服务端会把地区记为未知（null）。
 * 不兜底成某个具体地区，避免把「未知」上报成「美国」污染地区统计。
 */
const resolveClientLocale = (): string | undefined => {
    const lang = typeof navigator !== 'undefined' ? navigator.language : undefined;
    return lang && lang.trim() ? lang.trim() : undefined;
};

/**
 * 组装 §4.1.3 WebRequestContext 约定的公共请求头（X-Timezone/X-Client-Timestamp/X-Locale），
 * GraphQL（graphql/client.ts）与 REST（utils/portalRestClient.ts）两条链路共用。
 *
 * X-Locale 在取不到客户端地区时整体省略，其余两个头恒定下发。
 */
export const buildWebRequestHeaders = (): Record<string, string> => {
    const headers: Record<string, string> = {
        'X-Timezone': getBrowserTimeZone(),
        'X-Client-Timestamp': String(Date.now()),
    };

    const locale = resolveClientLocale();
    if (locale) {
        headers['X-Locale'] = locale;
    }
    return headers;
};
